const brandToastMsg = {
  /**
   *  [브랜드] 입점승인 브랜드 리스트 요청하기
   */
  GET_BRAND_JOIN_LIST_REQUEST_SUCCESS: '입점승인 브랜드 리스트 요청하기 성공',
  GET_BRAND_JOIN_LIST_REQUEST_ERROR: '입점승인 브랜드 리스트 요청하기 실패',

  /**
   *  [브랜드] 입점승인 브랜드 엑셀 다운로드 요청하기
   */
  GET_BRAND_JOIN_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '입점승인 브랜드 리스트 엑셀 다운로드 요청하기 성공',
  GET_BRAND_JOIN_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '입점승인 브랜드 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [브랜드] 브랜드 리스트 페이지 전체 데이터 요청하기
   */
  GET_BRAND_ALL_INFO_REQUEST_SUCCESS: '브랜드 리스트 페이지 전체 데이터 요청하기 성공',
  GET_BRAND_ALL_INFO_REQUEST_ERROR: '브랜드 리스트 페이지 전체 데이터 요청하기 실패',

  /**
   *  [브랜드] 브랜드 리스트 요청하기
   */
  GET_BRAND_LIST_REQUEST_SUCCESS: '브랜드 리스트 요청하기 성공',
  GET_BRAND_LIST_REQUEST_ERROR: '브랜드 리스트 요청하기 실패',

  /**
   *  [브랜드] 입점승인 브랜드 엑셀 다운로드 요청하기
   */
  GET_BRAND_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '브랜드 리스트 엑셀 다운로드 요청하기 성공',
  GET_BRAND_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '브랜드 리스트 엑셀 다운로드 요청하기 실패',

  /**
   * [브랜드] 브랜드 태그 검수 리스트 요청하기
   */
  GET_BRAND_TAG_REQUEST_LIST_REQUEST_SUCCESS: '브랜드 태그 검수 리스트 요청하기 성공',
  GET_BRAND_TAG_REQUEST_LIST_REQUEST_ERROR: '브랜드 태그 검수 리스트 요청하기 실패',

  /**
   * [브랜드] 브랜드 태그 검수 excel 리스트 다운로드 하기
   */
  GET_BRAND_TAG_REQUEST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '브랜드 태그 검수 리스트 엑셀 다운로드 요청하기 성공',
  GET_BRAND_TAG_REQUEST_EXCEL_DOWNLOAD_REQUEST_ERROR: '브랜드 태그 검수 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [브랜드] 브랜드 태그 리스트 요청하기
   */
  GET_BRAND_TAG_COLUMN_TAG_LIST_REQUEST_ERROR: '브랜드 태그 리스트 요청하기 실패',

  /**
   *  [브랜드] 브랜드 상세 요청하기
   */
  GET_BRAND_DETAIL_REQUEST_SUCCESS: '브랜드 상세 정보 요청하기 성공',
  GET_BRAND_DETAIL_REQUEST_ERROR: '브랜드 상세 정보 실패',

  /**
   *  [브랜드] 브랜드 상세 > 브랜드 정보 요청하기
   */
  GET_BRAND_DETAIL_INFO_REQUEST_SUCCESS: '브랜드 상세 브랜드 정보 요청하기 성공',
  GET_BRAND_DETAIL_INFO_REQUEST_ERROR: '브랜드 상세 브랜드 정보 요청하기 실패',

  /**
   *  [브랜드] 브랜드 상세 > 브랜드 정보 요청하기
   */
  GET_BRAND_DETAIL_STATISTIC_REQUEST_SUCCESS: '브랜드 상세 통계 정보 요청하기 성공',
  GET_BRAND_DETAIL_STATISTIC_REQUEST_ERROR: '브랜드 상세 통계 정보 요청하기 실패',

  /**
   *  [브랜드] 브랜드 상세 > 정산 정보 요청하기
   */
  GET_BRAND_DETAIL_ORDER_BALANCE_REQUEST_SUCCESS: '브랜드 상세 정산 정보 요청하기 성공',
  GET_BRAND_DETAIL_ORDER_BALANCE_REQUEST_ERROR: '브랜드 상세 정산 정보 요청하기 실패',

  /**
   *  [브랜드] 브랜드 상세 > 상품 정보 요청하기
   */
  GET_BRAND_DETAIL_PRODUCT_REQUEST_SUCCESS: '브랜드 상세 상품 정보 요청하기 성공',
  GET_BRAND_DETAIL_PRODUCT_REQUEST_ERROR: '브랜드 상세 상품 정보 요청하기 실패',

  /**
   *  [브랜드] 브랜드 상세 > 공지사항 정보 요청하기
   */
  GET_BRAND_DETAIL_NOTICE_PRODUCT_REQUEST_SUCCESS: '브랜드 상세 공지사항 정보 요청하기 성공',
  GET_BRAND_DETAIL_NOTICE_PRODUCT_REQUEST_ERROR: '브랜드 상세 공지사항 정보 요청하기 실패',

  /**
   *  [브랜드] 브랜드 상세 > 상품등록 정보 요청하기
   */
  GET_BRAND_DETAIL_PRODUCT_REGISTER_REQUEST_SUCCESS: '브랜드 상세 상품등록 정보 요청하기 성공',
  GET_BRAND_DETAIL_PRODUCT_REGISTER_REQUEST_ERROR: '브랜드 상세 상품등록 정보 요청하기 실패',

  /**
   *  [브랜드] 브랜드 상세 > 상품 리스트 엑셀 다운로드 요청하기
   */
  GET_BRAND_DETAIL_PRODUCT_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '브랜드 상품 정보 엑셀 다운로드 요청하기 성공',
  GET_BRAND_DETAIL_PRODUCT_EXCEL_DOWNLOAD_REQUEST_ERROR: '브랜드 상품 정보 엑셀 다운로드 요청하기 실패',

  /**
   *  [브랜드] 브랜드 상세 > 공지사항 리스트 엑셀 다운로드 요청하기
   */
  GET_BRAND_DETAIL_NOTICE_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '브랜드 공지사항 정보 엑셀 다운로드 요청하기 성공',
  GET_BRAND_DETAIL_NOTICE_EXCEL_DOWNLOAD_REQUEST_ERROR: '브랜드 공지사항 정보 엑셀 다운로드 요청하기 실패',

  /**
   *  [브랜드] 브랜드 입점승인하기
   */
  PERMIT_BRAND_REQUEST_SUCCESS: '브랜드 입점승인하기 성공',
  PERMIT_BRAND_REQUEST_ERROR: '브랜드 입점승인하기 실패',

  /**
   *  [브랜드] 브랜드 입점거절하기
   */
  REJECT_BRAND_REQUEST_SUCCESS: '브랜드 입점거절하기 성공',
  REJECT_BRAND_REQUEST_ERROR: '브랜드 입점거절하기 실패',

  /**
   *  [브랜드] 브랜드 정보 수정하기
   */
  EDIT_BRAND_REQUEST_SUCCESS: '브랜드 정보 수정하기 성공',
  EDIT_BRAND_REQUEST_ERROR: '브랜드 정보 수정하기 실패',

  /**
   *  [브랜드] 브랜드 상품등록 정보 수정하기
   */
  EDIT_BRAND_PRODUCT_REGISTER_REQUEST_SUCCESS: '브랜드 상품등록 정보 수정하기 성공',
  EDIT_BRAND_PRODUCT_REGISTER_REQUEST_ERROR: '브랜드 상품등록 정보 수정하기 실패',

  /**
   *  [브랜드] 브랜드 티어 정보 요청하기
   */
  GET_BRAND_TIER_INFO_REQUEST_SUCCESS: '브랜드 티어 정보 요청하기 성공',
  GET_BRAND_TIER_INFO_REQUEST_ERROR: '브랜드 티어 정보 요청하기 실패',

  /**
   *  [브랜드] 브랜드 티어 셀렉터 검색하기
   */
  GET_BRAND_TIER_SELECTOR_LIST_REQUEST_SUCCESS: '브랜드 티어 셀렉터 검색하기 성공',
  GET_BRAND_TIER_SELECTOR_LIST_REQUEST_ERROR: '브랜드 티어 셀렉터 검색하기 실패',

  /**
   *  [브랜드] 브랜드 티어 수정하기
   */
  EDIT_BRAND_TIER_LIST_REQUEST_SUCCESS: '브랜드 티어 수정하기 성공',
  EDIT_BRAND_TIER_LIST_REQUEST_ERROR: '브랜드 티어 수정하기 실패',

  /**
   *  [브랜드] 브랜드 상단 노출 리스트 정보 요청하기
   */
  GET_BRAND_EXPOSURE_INFO_REQUEST_SUCCESS: '브랜드 노출 리스트 정보 요청하기 성공',
  GET_BRAND_EXPOSURE_INFO_REQUEST_ERROR: '브랜드 노출 리스트 정보 요청하기 실패',

  /**
   *  [브랜드] 브랜드 노출 리스트 수정하기
   */
  EDIT_BRAND_EXPOSURE_LIST_REQUEST_SUCCESS: '브랜드 노출 순서 수정하기 성공',
  EDIT_BRAND_EXPOSURE_LIST_REQUEST_ERROR: '브랜드 노출 순서 수정하기 실패',

  /**
   *  브랜드 태그 승인하기
   */
  PERMIT_REGISTRATION_STORE_TAG_REQUEST_SUCCESS: '브랜드 태그 승인하기 성공',
  PERMIT_REGISTRATION_STORE_TAG_REQUEST_ERROR: '브랜드 태그 승인하기 실패',

  /**
   *  브랜드 태그 거절하기
   */
  REJECT_REGISTRATION_STORE_TAG_REQUEST_SUCCESS: '브랜드 태그 거절하기 성공',
  REJECT_REGISTRATION_STORE_TAG_REQUEST_ERROR: '브랜드 태그 거절하기 실패',
};

export default brandToastMsg;
